const React = require('react');

module.exports = ({className, ...props}) => (
  <div className={`layoutRow fxwWrap mh-5` + (className ? ` ${className}` : '')} {...props} />
)
